import React from 'react';
import ReactMarkdown from 'react-markdown';
import './Clientcarousel.css';

export default function ClientCarouselCard(props) {
  const [readMoreClicked, setReadMoreClicked] = React.useState(0);
  const readMoreClickHandler = (state) => {
    if (readMoreClicked === 0 && state !== 0) {
      setReadMoreClicked(state);
    } else if (readMoreClicked !== 0 && state === readMoreClicked) {
      setReadMoreClicked(0);
    }
  };
  // 0 is when both are closed
  // 1 is when first(above) is open
  // 2 is when second(below) is open
  console.log(props.data);
  return (
    <>
      {(readMoreClicked === 0 || readMoreClicked === 1) && (
        <div
          key={props.data[0].id}
          className={` showcase_item showcase_odd_client `}
          style={{
            paddingTop: readMoreClicked === 1 ? '75%' : '',
          }}
        >
          <div className=" showcase_item__content">
            <h3
              style={{
                fontSize: '20px',
                textTransform: 'uppercase',
                textAlign: 'left',
              }}
            >
              {props.data[0].title}
            </h3>
            <div
              className="showcase_item_body_carousel"
              id="showcase_item_body_carousel"
              style={{
                textAlign: 'left',
                fontSize: '14px',
              }}
            >
              {readMoreClicked === 1 ? (
                <ReactMarkdown>{props.data[0].article}</ReactMarkdown>
              ) : (
                props.data[0].info
              )}
            </div>
            <div
              onClick={() => readMoreClickHandler(1)}
              className="link"
              style={{ color: 'black', cursor: 'pointer', fontSize: '14px' }}
            >
              Read {readMoreClicked === 1 ? 'Less' : 'More'}
            </div>
          </div>
        </div>
      )}
      {(readMoreClicked === 0 || readMoreClicked === 2) && props.data[1] && (
        <div
          key={props.data[1].id}
          className={`showcase_item showcase_odd_client`}
          style={{
            // margin: "auto",
            marginLeft: 4,
            marginRight: 4,
            paddingTop: readMoreClicked === 2 ? '80%' : 0,
          }}
        >
          <div className="showcase_item__content">
            <h3
              style={{
                fontSize: '20px',
                textTransform: 'uppercase',
                textAlign: 'left',
              }}
            >
              {props.data[1].title}
            </h3>
            <div
              className="showcase_item_body_carousel"
              id="showcase_item_body_carousel"
              style={{
                textAlign: 'left',
                fontSize: '14px',
              }}
            >
              {readMoreClicked === 2 ? (
                <ReactMarkdown>{props.data[1].article}</ReactMarkdown>
              ) : (
                props.data[1].info
              )}
            </div>
            <div
              onClick={() => readMoreClickHandler(2)}
              className="link"
              style={{ color: 'black', cursor: 'pointer', fontSize: '14px' }}
            >
              Read {readMoreClicked === 2 ? 'Less' : 'More'}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
